import type { TFunction } from "i18next";
import type { AgentRoute, ApiKeyRoute } from "../../../api/threads/liveMessages";

/** "agent fake, model fake-model-a", or "agent fake" on its default model: the route a turn ran on. */
export function routeLabel(route: AgentRoute | ApiKeyRoute, t: TFunction): string {
  if (route.kind === "api_key") {
    return t("threads.turn.apiRoute", { route: route.route_id, model: route.model_id });
  }
  return route.model_id === null ? t("threads.turn.agentOnly", { agent: route.agent_id }) : t("threads.turn.agentRoute", { agent: route.agent_id, model: route.model_id });
}
